import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { authSimpleCanActivate } from "@delon/auth";
import { LayoutDefaultComponent } from "src/app/layout/default/default.component";
import { EnquiryComponent } from "./enquiry.component";
import { TicketCategoryComponent } from "./ticket-category/ticket-category.component";
import { TicketInformationComponent } from "./ticket-information/ticket-information.component";

const routes: Routes = [
  {
    path: "",
    component: LayoutDefaultComponent,
    canActivate: [authSimpleCanActivate],
    data: { title: "WAEC Enquiry", titleI18n: "CORE.MENU.ENQUIRY" },
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "tickets",
      },
      {
        path: "tickets",
        component: EnquiryComponent,
        data: {
          title: "WAEC Enquiry",
          titleI18n: "CORE.MENU.ENQUIRY",
        },
      },
      {
        path: "ticket-info/:id",
        component: TicketInformationComponent,
        data: {
          title: "WAEC Enquiry",
          titleI18n: "CORE.MENU.ENQUIRY",
        },
      },
      {
        path: "open-ticket",
        component: TicketCategoryComponent,
        data: {
          title: "WAEC Enquiry",
          titleI18n: "CORE.MENU.ENQUIRY",
        },
      },
      {
        path: "open-ticket/:complaint",
        component: TicketCategoryComponent,
        data: {
          title: "WAEC Enquiry",
          titleI18n: "CORE.MENU.ENQUIRY",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EnquiryRoutingModule {}
